import React from 'react';
import PropTypes from 'prop-types';
import { map, groupBy, get, pull, find } from 'lodash';
import CheckoutAddOnCard from '../../../../app-bookings-request/CheckoutAddOnCard';
import categoryIcons from '../../../data/addOnCategoryIcons';

const AddOnsCards = ({
  fields = [],
  addOnsValues = [],
  handleAddOnChange = null,
  displayAddOns = [],
  formName = '',
  dispatch = null,
  bookingId = '',
  spaceRental = {},
  displayConciergeBanner = true,
  toggleModal = null,
  whichModal = null,
  addOnsCategories = []
}) => {
  const addOnFields = fields.map((field, index) => {
    const selectedAddOn = addOnsValues[index];
    const addOnData = displayAddOns[index];

    return (
      <span key={`addon-field-${index}`}>
        <CheckoutAddOnCard
          key={field}
          index={index}
          addOnData={addOnData}
          addOn={displayAddOns[index]}
          field={field}
          handleAddOnChange={handleAddOnChange}
          dispatch={dispatch}
          formName={formName}
          selectedAddOn={selectedAddOn}
          toggleModal={toggleModal}
          whichModal={whichModal}
        />
      </span>
    );
  });

  const groupByCategory = groupBy(
    addOnFields,
    'props.children.props.addOnData.category'
  );
  const categoryKeys = pull(Object.keys(groupByCategory), 'food_drinks');
  // shift food and drinks category to the front of the array so that we display it first
  const shiftCategories = () => {
    if (groupByCategory.food_drinks && 'food_drinks' !== categoryKeys[0]) {
      return ['food_drinks', ...categoryKeys];
    }

    return categoryKeys;
  }

  return (
    <div className="AddOnsCards">
      {
        map(shiftCategories(), (categoryKey) => {
          const category = find(addOnsCategories, { id: categoryKey });
          const categoryDisplayString = get(category, 'name', '');
          const Icon = categoryIcons[categoryKey];
          return (
            <div
              className="overflow-hidden margin-xl-top"
              key={categoryKey}
              data-testing-id='add-on-category'
            >
              <div className="category-title flex">
                {Icon
                  && <Icon
                    className="icon margin-md-right"
                    alt={`${categoryKey} Icon`}
                  />
                }

                <h4 className='h5'>{categoryDisplayString}</h4>
              </div>
              {
                map(groupByCategory[categoryKey], (addOnEl) => {
                  return addOnEl;
                })
              }
            </div>
          );
        })
      }
    </div>
  )
}

AddOnsCards.propTypes = {
  fields: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object // https://redux-form.com/8.3.0/docs/api/fieldarray.md/
  ]),
  addOnsValues: PropTypes.array,
  handleAddOnChange: PropTypes.func,
  displayAddOns: PropTypes.array,
  formName: PropTypes.string,
  dispatch: PropTypes.func,
  spaceRental: PropTypes.object,
  addOnsCategories: PropTypes.array
};

export default AddOnsCards;
